import { DataTable, EunoiaImageInput, LoadingButton, SectionTitle, TableHeading } from 'components';
import React, { useState } from 'react';
import { I18n } from 'core';
import { ReactComponent as LandscapeIcon } from 'assets/icons/Landscape.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/Trash.svg';
import { Colors } from 'styles';

import customToast from 'components/CustomToast/CustomToast';
import { toast } from 'react-toastify';
import { LoggingService } from 'services';
import { CustomizableImageType } from 'types/models';
import PromotorCustomOnboardingServiceInstance from 'services/remote/PromotorCustomOnboardingService';
import styles from './promotor-custom-onboarding-image-form.module.scss';

export interface CustomizableImage {
  id: string;
  url: string;
}
interface PromotoresCustomOnboardingImageFormProps {
  images: Array<CustomizableImage>;
  afterSubmitAction?: CallableFunction;
  communitiyId: string;
}
export const PromotoresCustomOnboardingImageForm = ({
  communitiyId,
  images,
  afterSubmitAction,
}: PromotoresCustomOnboardingImageFormProps): JSX.Element => {
  // const [image] = images;
  // const [fileName, setFileName] = useState<string>(image?.url);
  const [loading, setLoading] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
  const [file, setFile] = useState<File>();
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const validateForm = (): boolean => {
    if (!file) {
      setSubmitDisabled(true);
      setErrors({});
      return false;
    }
    setSubmitDisabled(false);
    setErrors({});
    return true;
  };
  const submitForm = async (): Promise<boolean> => {
    setLoading(true);
    setSubmitDisabled(true);

    try {
      if (file) {
        const response = await PromotorCustomOnboardingServiceInstance.addImage(communitiyId, file);
        if (response === 201) {
          customToast.success(I18n.t('Image saved!'));

          if (afterSubmitAction) {
            afterSubmitAction(communitiyId);
          }

          //   setSubmitDisabled(false);
        }
      }
    } catch (error) {
      toast.error(I18n.t('Error Uploading gallery image.'));
      setSubmitDisabled(false);
      setLoading(false);
      setFile(undefined);
    }

    // setLoading(false);
    // setFile(undefined);

    return true;
  };
  const settingFile = (file1: File): void => {
    if (file1) {
      setFile(file1);
      setIsButtonDisabled(false);
    }
  };
  const onSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    if (validateForm()) {
      LoggingService.log('handleSubmit :: ok', { file });
      submitForm();
    } else {
      LoggingService.log('handleSubmit :: errors', { file, errors });
    }
  };

  const deleteImage = async (imagedel: any): Promise<void> => {
    // eslint-disable-next-line no-alert
    const accept = window.confirm(I18n.t('Are you sure you want to delete the image?'));

    if (!accept) {
      return;
    }

    try {
      await PromotorCustomOnboardingServiceInstance.deleteImage(communitiyId, imagedel.id);

      customToast.success(`${I18n.t('Image deleted successfully')}!`);

      if (afterSubmitAction) {
        afterSubmitAction(communitiyId);
      }
      setSubmitDisabled(false);
    } catch (error) {
      toast.error(`${I18n.t('Error deleting image')}.`);
    }
  };

  const headings: Array<TableHeading> = [
    { label: I18n.t('Image'), type: 'image', key: 'url' },

    {
      label: I18n.t('Actions'),
      type: 'actions',
      key: '',
      actions: [
        {
          label: I18n.t('Delete'),
          icon: <TrashIcon height={25} width={25} fill={Colors.COLOR_ELECSUMGREEN} />,
          onActionClick: deleteImage,
        },
      ],
    },
  ];

  return (
    <>
      <div className={styles.flex}>
        <LandscapeIcon height={20} width={20} fill={Colors.COLOR_BLACK} className={styles.LandscapeIcon} />
        <SectionTitle text={I18n.t('ComunidadesCustomOnboardingProcess.form.logo.title')} />
      </div>
      {images.length <= 0 ? (
        <form className={styles.form} onSubmit={onSubmit}>
          <div className={styles.fields}>
            <EunoiaImageInput
              id={CustomizableImageType.LOGO}
              label={I18n.t('ComunidadesCustomOnboardingProcess.form.logo.text')}
              note={I18n.t('ComunidadesCustomOnboardingProcess.form.logo.note')}
              fileName=""
              icon={<LandscapeIcon height={20} width={20} fill={Colors.COLOR_GRAY_400} />}
              type={CustomizableImageType.LOGO}
              action={settingFile}
            />
          </div>
          <div className={styles.actions}>
            <LoadingButton
              type="submit"
              text="Guardar imagen"
              disabled={isButtonDisabled || submitDisabled}
              loading={loading}
            />
          </div>
        </form>
      ) : null}

      <div className="col-12">
        <div className="table-news">
          {images && images.length > 0 ? <DataTable headings={headings} rows={images} loading={loading} /> : null}
        </div>
      </div>
    </>
  );
};
